import { v4 as uuid } from 'uuid';

type CancellationTokenState = 'active' | 'cancelled' | 'disposed';

export class CancellationToken {
	private _state: CancellationTokenState = 'active';
	readonly token: string = null;

	constructor(token?: string) {
		this.token = token || ('deferred:' + uuid());
		window[this.token] = 'active';
	}

	get state(): CancellationTokenState {
		if (this._state !== 'disposed' && window[this.token] === 'cancelled')
			this._state = 'cancelled';

		return this._state;
	}

	get isActive() {
		return this.state === 'active';
	}

	get isCancelled() {
		return this.state === 'cancelled';
	}

	cancel() {
		window[this.token] = this._state = 'cancelled';
	}

	dispose() {
		delete window[this.token];
		this._state = 'disposed';
	}
}
